import { redirect } from 'react-router';

import { getIdentity } from './firebase.tsx';

export async function requiresAuth(request: Request) {
  const identity = await getIdentity();
  if (!identity) {
    // Carry a pending course through sign-in, so a learner whose session
    // expired at checkout resumes there instead of landing on the dashboard.
    const course = new URL(request.url).searchParams.get('course');

    throw redirect(
      course ? `/signin?course=${encodeURIComponent(course)}` : '/signin',
    );
  }
  return identity;
}
